<div class="filter-list" [ngClass]="{'m-t-md': labelsList.length > 0}">
    <span class="filter-item" *ngFor="let item of labelsList">
        {{item}}
    </span>
    <a (click)="clearFilters()" class="clear-filters" *ngIf="labelsList.length">
        Clear Filter
    </a>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/filters-view/filters-view.component.html